module.exports = __webpack_public_path__ + "img/operation@3x.8d63b7ea.png";